import React, { useEffect, useState } from 'react';
import '../../styles/Admin/admin_alumniDetail.css';
import moment from 'moment';
import Toast from 'awesome-toast-component';
import { useNavigate } from 'react-router-dom';
import { displaySnackbar, YesNoSelector } from '../../utilities';

export default function Admin_AlumniDetail({ announcement, fetchAnnouncements }) {
    const [tab, setTab] = useState('Details');
    const [fetched_announcement, setFetchedAnnouncement] = useState(announcement);
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`http://localhost:5000/announcements/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_announcement = response?.announcement;
                setFetchedAnnouncement(the_announcement);
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    }, []);

    // 👇️ handler to delete an announcement
    const deleteAnnouncement = (id) => {
        YesNoSelector('Are you sure you want to delete this announcement?', (reply) => {
            if (reply === 'yes') {
                fetch(`http://localhost:5000/announcements/remove`, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                })
                    .then(async (result) => {
                        let response = await result?.json();
                        if (response?.msg === null) {
                            displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                        } else {
                            console.log(response);
                            displaySnackbar(response?.msg, false, 'Ok', () => {});
                            setTimeout(() => {
                                fetchAnnouncements();
                                navigate('/admin.console/announcements');
                            }, 1000);
                        }
                    })
                    .catch((error) => {
                        if (error?.message == 'Failed to fetch') {
                            displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                        } else {
                            displaySnackbar('Some error occurred!', true, 'Ok', () => {});
                            console.log('the error:', error);
                        }
                    });
            }
        });
    };

    return (
        <div className='alumni-detail'>
            {/* go back button */}
            <button onClick={() => navigate('/admin.console/announcements/')}>👈️ Go Back</button>

            {/* header bar */}
            <div className='alumni-detail-header-bar'>
                <div className='left'>
                    <h1>Announcement Detail</h1>
                </div>
                <div className='right'></div>
            </div>

            {/* alumni content */}
            <div className='alumni-detail-main-content'>
                {tab === 'Details' ? (
                    <div className='details'>
                        <span className='details-sub-header'>Announcement Information</span>

                        <div className='details-content-item'>
                            <span className='title'>Actions</span>
                            <button
                                style={{ backgroundColor: 'orangered' }}
                                onClick={() => deleteAnnouncement(fetched_announcement?.uuid)}
                            >
                                Delete this announcement
                            </button>
                            <button
                                style={{ backgroundColor: 'green' }}
                                onClick={() =>
                                    navigate(
                                        `/admin.console/announcements/edit/${fetched_announcement?.uuid}`
                                    )
                                }
                            >
                                Edit this announcement
                            </button>
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Details</span>
                            {fetched_announcement?.details?.length > 0 ? (
                                <p className='text about'>{fetched_announcement?.details}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-items'>
                            <div className='details-content-item'>
                                <span className='title'>id</span>
                                {fetched_announcement?.id > 0 ? (
                                    <p className='text'>{fetched_announcement?.id}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>user id (uuid)</span>
                                {fetched_announcement?.uuid?.length > 0 ? (
                                    <p className='text'>{fetched_announcement?.uuid}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Title</span>
                                {fetched_announcement?.title?.length > 0 ? (
                                    <p className='text'>{fetched_announcement?.title}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>priority</span>
                                {fetched_announcement?.priority?.length > 0 ? (
                                    <p className='text'>{fetched_announcement?.priority}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Posted on</span>
                                {fetched_announcement?.createdAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(
                                            new Date(fetched_announcement?.createdAt)
                                        ).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Last updated on</span>
                                {fetched_announcement?.updatedAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(
                                            new Date(fetched_announcement?.updatedAt)
                                        ).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <h1>Conversations</h1>
                )}
            </div>
        </div>
    );
}
